import { Button, Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../../components/UI'

export default function MCFeatureDisabledPage() {
  return (
    <div className="max-w-3xl mx-auto py-10">
      <Card>
        <CardHeader>
          <CardTitle>Funcionalidad no habilitada</CardTitle>
          <CardDescription>
            Tu cuenta no tiene una licencia activa para la calculadora de materiales.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-3">
          <p className="text-sm text-gray-600">Activa la licencia para acceder al asistente, reportes y reglas versionadas.</p>
          <div className="flex gap-2">
            <Button onClick={() => window.location.href = '/dashboard'}>Ir a mis productos</Button>
            <Button variant="outline" onClick={() => window.location.href = 'mailto:soporte@appemprendedor.com'}>
              Contactar soporte
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
